import React from 'react';
import { FaCaretLeft, FaCaretRight } from 'react-icons/fa';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Flexed container
 */
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
`;

/**
 * Button to incriment with
 */
const Button = styled.div`
  width: 3em;
  padding: 0 1em;
  cursor: pointer;
  > svg {
    display: block;
  }
`;

/**
 * Label
 */
const CurrentSelectionLabel = styled.div`
  font-size: 1.4em;
  font-weight: bold;
`;

/**
 * Increment selector
 * Used to allow incremental/decremental selection of items
 * @reactProps {function(direction: number): void} onClick Callback passing 1 when next item pressed, -1 when last
 */
const IncrementSelector = ({ children, onClick }) => (
  <Container>
    <Button
      onClick={() => {
        onClick(-1);
      }}
    >
      <FaCaretLeft size="100%" />
    </Button>
    <CurrentSelectionLabel>{children}</CurrentSelectionLabel>
    <Button
      onClick={() => {
        onClick(1);
      }}
    >
      <FaCaretRight size="100%" />
    </Button>
  </Container>
);

IncrementSelector.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default IncrementSelector;
